(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSitePart', PublicSitePart);

    PublicSitePart.$inject = ['$resource'];

    function PublicSitePart ($resource) {
        var resourceUrl =  'api/public-site-parts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
